(() => {
  if (window.PgQtyBundle) {
    window.PgQtyBundle.initAll();
    return;
  }

  const init = (root) => {
    if (root.dataset.pgQtyBundleReady === 'true') return;

    const sectionId = root.dataset.sectionId;
    const form = document.getElementById(root.dataset.productFormId);
    const submitLabel = form?.querySelector('.product-form__submit > span:first-child');
    const liveRegion = root.querySelector('[data-pg-qty-bundle-live]');
    const choices = Array.from(root.querySelectorAll('input[data-pg-qty-choice]'));
    const packSize = parseInt(root.dataset.stufe, 10);

    if (!form || !submitLabel || choices.length !== 2 || !(packSize >= 2)) return;

    // Das Mengenfeld steht im Theme außerhalb des Formulars (form="product-form-…").
    let quantityInput =
      document.getElementById(`Quantity-${sectionId}`) ||
      form.elements.namedItem('quantity') ||
      root.closest('product-info')?.querySelector('input[name="quantity"]');
    if (!quantityInput) {
      // Template ohne Mengenauswahl: verstecktes Feld, damit das Pack mit Menge k in den Warenkorb geht.
      quantityInput = document.createElement('input');
      quantityInput.type = 'hidden';
      quantityInput.name = 'quantity';
      quantityInput.value = '1';
      form.appendChild(quantityInput);
    }

    root.dataset.pgQtyBundleReady = 'true';
    const originalSubmitText = submitLabel.textContent.trim();
    let settingQuantity = false;

    const announce = (text) => {
      if (!liveRegion) return;
      liveRegion.textContent = '';
      window.requestAnimationFrame(() => {
        liveRegion.textContent = text;
      });
    };

    const markSelection = (choice) => {
      const usePack = choice === 'pack';
      choices.forEach((input) => {
        input.checked = input.value === choice;
      });
      submitLabel.textContent = usePack ? root.dataset.packLabel : originalSubmitText;
      root.dataset.pgQtyBundleSelection = choice;
    };

    const select = (choice, shouldAnnounce = true) => {
      const usePack = choice === 'pack';
      const quantity = String(usePack ? packSize : 1);
      markSelection(choice);
      if (quantityInput.value !== quantity) {
        quantityInput.value = quantity;
        settingQuantity = true;
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        settingQuantity = false;
      }
      if (shouldAnnounce) announce(usePack ? root.dataset.packAnnouncement : root.dataset.singleAnnouncement);
    };

    root.addEventListener('change', (event) => {
      if (event.target.matches('input[data-pg-qty-choice]') && event.target.checked) {
        select(event.target.value);
      }
    });

    // Menge weg von k: Pack-Wahl aufheben, die gesetzte Menge bleibt stehen.
    const syncWithQuantity = () => {
      if (settingQuantity || root.dataset.pgQtyBundleSelection !== 'pack') return;
      if (parseInt(quantityInput.value, 10) !== packSize) markSelection('single');
    };
    quantityInput.addEventListener('change', syncWithQuantity);

    // Dawn setzt die Menge nach dem Warenkorb still zurück (product-info.js setQuantityBoundries) und meldet das
    // nur über quantityUpdate.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.quantityUpdate, syncWithQuantity);
    }

    // Absenden mit gewähltem Pack geht immer mit Menge k. Capture am Dokument läuft sicher vor Dawns
    // Submit-Handler am Formular.
    document.addEventListener(
      'submit',
      (event) => {
        if (event.target === form && root.dataset.pgQtyBundleSelection === 'pack') {
          quantityInput.value = String(packSize);
        }
      },
      true
    );

    const restored = choices.find((input) => input.checked && input.value === 'pack');
    if (restored && parseInt(quantityInput.value, 10) === packSize) {
      markSelection('pack');
    } else {
      select('single', false);
    }
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-pg-qty-bundle]').forEach(init);
  };

  window.PgQtyBundle = { initAll };
  initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
